"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var UpsellModalV2_1 = require("../common/UpsellModalV2");
var CartContext_1 = require("./CartContext");
var cart_1 = require("../../utils/cart");
var ga_1 = require("../../utils/ga");
var Parser_1 = require("../Parser");
var AddToCart_1 = require("../common/AddToCart");
var UpgradeToSubOrBundle = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var prod = _a.prod;
    if (!prod) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var upsellModalData = ((_b = prod.upsellModalData) === null || _b === void 0 ? void 0 : _b.reference.field.value) &&
        JSON.parse((_c = prod.upsellModalData) === null || _c === void 0 ? void 0 : _c.reference.field.value);
    var _w = (0, hooks_1.useContext)(CartContext_1.default), cart = _w.cart, cartOpen = _w.open, renderCart = _w.renderCart;
    var _x = (0, hooks_1.useState)(false), open = _x[0], setOpen = _x[1];
    (0, hooks_1.useEffect)(function () {
        if (!cartOpen && open) {
            setOpen(false);
        }
    }, [cartOpen]);
    var isSubscription = (0, cart_1.isSubscriptionItem)(prod);
    var replacedItem = cart.items.find(function (cartItem) { var _a; return cartItem.handle === ((_a = prod.replace) === null || _a === void 0 ? void 0 : _a.value); });
    if (prod.title === 'Get Your Body Back Bundle') {
        replacedItem = cart.items.find(function (cartItem) { return cartItem.handle === 'meno-menopause-vitamin-capsule'; });
    }
    if (prod.title === 'FLO - PMS Vitamin Capsules') {
        replacedItem = cart.items.find(function (cartItem) { return cartItem.handle === 'flo-pms-vitamin-capsule'; });
    }
    if (prod.title === 'FLO - PMS Gummy Vitamins') {
        replacedItem = cart.items.find(function (cartItem) { return cartItem.handle === 'flo-pms-gummy-vitamin'; });
    }
    if (prod.title === 'Metabolism + Period Bundle') {
        var floPmsCapsuleInCart = cart.items.find(function (cartItem) { return cartItem.handle === 'flo-pms-vitamin-capsule-o2'; });
        if (floPmsCapsuleInCart) {
            replacedItem = floPmsCapsuleInCart;
        }
        var floPmsGummyInCart = cart.items.find(function (cartItem) { return cartItem.handle === 'flo-pms-gummy-vitamin-o2'; });
        if (floPmsGummyInCart) {
            replacedItem = floPmsGummyInCart;
        }
    }
    if (window.cartQuantityTest && prod.title === 'Vaginal & Urinary Health Bundle') {
        replacedItem = cart.items.find(function (cartItem) { return cartItem.handle === 'uro-vaginal-probiotic-capsule'; });
    }
    var handleCtaClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    if (!replacedItem) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, cart_1.updateCart)(event, replacedItem)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, cart_1.addItem)(event.target)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [4 /*yield*/, renderCart()];
                case 5:
                    _b.sent();
                    (0, ga_1.sendEventAddToCart)(prod, (_a = prod.variants) === null || _a === void 0 ? void 0 : _a.nodes[0], ga_1.GaMethodValue.cartUpsell);
                    return [2 /*return*/];
            }
        });
    }); };
    var upsellTitle = prod.title;
    var upsellDescription = prod.upsellCardText && prod.upsellCardText.value;
    var compareAtPrice = ((_d = prod.variants.nodes[0]) === null || _d === void 0 ? void 0 : _d.compareAtPrice) && +((_f = (_e = prod.variants.nodes[0]) === null || _e === void 0 ? void 0 : _e.compareAtPrice) === null || _f === void 0 ? void 0 : _f.amount);
    var price = +((_g = prod.variants.nodes[0]) === null || _g === void 0 ? void 0 : _g.price.amount);
    // value for save xx% in description
    var saveAmount = compareAtPrice && compareAtPrice !== 0
        ? (((compareAtPrice - price) / compareAtPrice) * 100).toFixed(0)
        : null;
    // AB test different name and description for upsells
    if (window.isCartUpsellTest) {
        if ((_j = (_h = prod.includes) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.includes(',')) {
            // upsell multi bundles
            upsellTitle = 'Upgrade to the ' + prod.title;
            upsellDescription =
                'Customer favorite - target multiple concerns [br]Save ' +
                    (saveAmount === null || saveAmount === void 0 ? void 0 : saveAmount.toString()) +
                    '% & unlock FREE shipping';
        }
        else {
            if ((_l = (_k = prod.includes) === null || _k === void 0 ? void 0 : _k.value) === null || _l === void 0 ? void 0 : _l.includes('=1')) {
                // upgrade to 1b sub
                upsellTitle = 'Subscribe to unlock ' + (saveAmount === null || saveAmount === void 0 ? void 0 : saveAmount.toString()) + '% extra savings';
                upsellDescription =
                    'Get better results with consistent use [br]1 bottle delivers every month, [bold]((free shipping))';
            }
        }
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item" },
            (0, preact_1.h)("img", { class: "cart-section__you-may-also-like-item-image", src: (_m = prod.featuredImage) === null || _m === void 0 ? void 0 : _m.src }),
            (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info" },
                (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info-product" },
                    prod.title.includes('RETRO - Glowing Skin') && ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-badge" }, "Save an additional $5")),
                    ((_o = prod.upsellStatus) === null || _o === void 0 ? void 0 : _o.value) && ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-badge" }, prod.upsellStatus.value)),
                    (0, preact_1.h)("div", null,
                        (0, preact_1.h)("h4", { class: "cart-section__you-may-also-like-item-header" }, (0, Parser_1.parse)(upsellTitle)),
                        (0, preact_1.h)("p", { class: "cart-section__you-may-also-like-item-body" }, upsellDescription && (0, Parser_1.parse)(upsellDescription))),
                    (0, preact_1.h)("div", null, !prod.title.toLowerCase().includes('meno') && upsellModalData && ((0, preact_1.h)("button", { onClick: function () { return setOpen(true); }, class: "cart-section__you-may-also-like-item-button" },
                        (0, preact_1.h)("span", { class: "cart-section__you-may-also-like-item-button-text" }, "Learn More"),
                        "\u2192")))),
                (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price-cta" },
                    ((_q = (_p = prod.variants) === null || _p === void 0 ? void 0 : _p.nodes) === null || _q === void 0 ? void 0 : _q.length) && ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price" },
                        prod.variants.nodes[0].compareAtPrice && ((0, preact_1.h)("span", { class: "cart-section__you-may-also-like-item-price--strikethrough" }, (0, hydrogen_react_1.useMoney)({
                            amount: String(Math.ceil(+prod.variants.nodes[0].compareAtPrice.amount)),
                            currencyCode: 'USD',
                        }).withoutTrailingZeros)),
                        "\u00A0",
                        (0, hydrogen_react_1.useMoney)(prod.variants.nodes[0].price).withoutTrailingZeros,
                        isSubscription ? '/mo' : '')),
                    (0, preact_1.h)("div", null,
                        (0, preact_1.h)("form", { method: "POST", action: "/cart/add", class: "trigger--cart trigger--replace", "data-replace-item": replacedItem === null || replacedItem === void 0 ? void 0 : replacedItem.id, onSubmit: function (event) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, handleCtaClick(event)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); } },
                            (0, preact_1.h)("input", { type: "hidden", name: "quantity", value: "1" }),
                            (0, preact_1.h)("input", { type: "hidden", name: "id", value: Number((_r = prod.variants.nodes[0]) === null || _r === void 0 ? void 0 : _r.id.split('/')[4]) }),
                            prod.sellingPlanGroups.nodes.length ? ((0, preact_1.h)("input", { type: "hidden", name: "selling_plan", value: Number((_v = (_u = (_t = (_s = prod.sellingPlanGroups.nodes[0]) === null || _s === void 0 ? void 0 : _s.sellingPlans) === null || _t === void 0 ? void 0 : _t.nodes[0]) === null || _u === void 0 ? void 0 : _u.id) === null || _v === void 0 ? void 0 : _v.split('/')[4]) })) : ((0, preact_1.h)(preact_1.Fragment, null)),
                            (0, preact_1.h)("button", { type: "submit", class: "cart-section__you-may-also-like-item-cta" }, "Apply Offer")))))),
        upsellModalData && ((0, preact_1.h)(UpsellModalV2_1.default, { open: open, setOpen: setOpen, price: prod.variants.nodes[0].price, upsellModalData: upsellModalData, handleAddToCart: function () { return (0, AddToCart_1.handleAddToCart)(upsellModalData.product); } }))));
};
exports.default = UpgradeToSubOrBundle;
